import { useAuth } from "../lib/auth";
import { ArrowLeft, UserCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Top banner shown when a super_admin is impersonating another user.
 * Offers a quick "Volver a mi sesión" button to restore the original token.
 */
export default function ImpersonationBanner() {
    const { impersonator, stopImpersonation, user } = useAuth();
    const navigate = useNavigate();
    if (!impersonator) return null;
    const handleStop = () => {
        stopImpersonation();
        // SPA navigation back to the admin users page — `stopImpersonation`
        // already swapped tokens + user state, so React re-renders with
        // the original session in place. No hard reload needed.
        navigate("/users");
    };
    return (
        <div
            data-testid="impersonation-banner"
            className="sticky top-0 z-50 bg-periwinkle-500 text-ink-950 px-4 py-2 flex items-center gap-3 shadow-glow-sm"
        >
            <UserCheck className="w-4 h-4 shrink-0" />
            <p className="text-sm font-medium truncate flex-1">
                Estás viendo la plataforma como{" "}
                <strong>{user?.name || user?.email}</strong> · Impersonado por{" "}
                <span className="font-mono text-xs">{impersonator.email}</span>
            </p>
            <button
                data-testid="impersonation-stop-btn"
                onClick={handleStop}
                className="rounded-lg bg-ink-950 text-periwinkle-500 px-3 py-1.5 text-xs font-mono uppercase tracking-widest flex items-center gap-1.5 hover:bg-ink-900 transition-colors shrink-0"
            >
                <ArrowLeft className="w-3 h-3" />
                Volver a mi sesión
            </button>
        </div>
    );
}
